import type { RouteRecordRaw } from 'vue-router';

export const routes: RouteRecordRaw[] = [

  {
    name: 'abaclik',
    path: 'abaclik',
    component: () => import('../AbaclikIndex.vue'),
  },
];
